import React, {Fragment, useContext, useEffect} from 'react';
import {ServerContext} from "./serverContext/ServerProvider";
import {Content} from "./components/Content";
import {Loader} from "./components/Loader";

function App() {
    const {goods, init, mainLoading} = useContext(ServerContext)

    useEffect(() => {
        async function wtf() {
            await init()
        }

        wtf()
    }, [])

    return (
        <Fragment>
            {mainLoading ? <Loader/> : (
                <div className='container-fluid'>
                    <Content goods={goods}/>
                </div>
            )}
        </Fragment>
    );
}

export default App;
